var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDyslexia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.82 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.64,54.51c-5.65,5.65-14.81,5.65-20.45,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "19.77 58.49 19.19 54.51 23.16 53.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.19,4.99c5.65-5.65,14.81-5.65,20.45,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.05 1.01 39.64 4.99 35.66 5.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.79,49.94v-12.4c-3.24-2.87-5.28-7.01-5.28-11.61,0-8.66,7.2-15.67,16.07-15.67s16.06,7.01,16.06,15.67c0,.6-.03,1.19-.1,1.78-.03.29.02.59.17.84l3.22,5.65c.39.67,0,1.51-.75,1.68l-3.31.68v5.36c0,.92-.75,1.68-1.69,1.68h-7.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.45,40.6l1.15,1.14c1.19,1.19,2.81,1.86,4.5,1.86"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.49,
    y1: 43.6,
    x2: 46.49,
    y2: 49.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.72,43.6h-7.07c-.94,0-1.69-.74-1.69-1.67v-5.36l-3.3-.69c-.75-.15-1.14-1-.75-1.67l3.22-5.65c.14-.26.2-.56.16-.84-.07-.59-.1-1.18-.1-1.78,0-8.66,7.18-15.66,16.05-15.66,3.41,0,6.57,1.03,9.17,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.37,40.6l-1.15,1.14c-1.19,1.19-2.81,1.86-4.5,1.86"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.34,
    y1: 49.94,
    x2: 12.34,
    y2: 43.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDyslexia);
export default __webpack_public_path__ + "static/media/dyslexia.a1a70dfaf85dee62bfe5cbc66c1c899e.svg";
export { ForwardRef as ReactComponent };